if (!customElements.get("compatibility-popup")) {
  customElements.define(
    "compatibility-popup",
    class CompatibilityPopup extends HTMLElement {
      constructor() {
        super();
        this.steps = {};
        this.currentStep = null;
        // Liste des sélecteurs à conserver lors de l'injection du formulaire
        this.elementsToKeep = ["deployer-quantity-breaks", "form", ".custom-scalapay", ".carte-reassurance_reassurances"];
        // Historique de navigation pour le bouton retour
        this.navigationHistory = [];
      }

      connectedCallback() {
        // Initialiser les références DOM
        this.modal = document.querySelector("#Modal-popup-compatibility");
        this.closeButton = document.querySelector("#ModalClose-popup-compatibility");
        this.backButton = document.querySelector("#ModalBack-popup-compatibility");

        // Initialiser les étapes
        this.initSteps();

        // Ajouter les écouteurs d'événements pour les boutons
        this.addButtonEventListeners();

        // Ajouter l'écouteur pour le bouton de retour
        if (this.backButton) {
          this.backButton.addEventListener("click", () => this.goBack());
        }

        // Afficher la première étape si la modale est déjà ouverte
        if (this.modal && this.modal.hasAttribute("open")) {
          this.showFirstStep();
        }

        // Ajouter un écouteur pour réinitialiser quand modal-dialog est fermée/ouverte
        if (this.modal) {
          // Utiliser l'attribut 'open' de modal-dialog pour détecter quand la modale est fermée/ouverte
          const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (mutation.attributeName === "open") {
                if (!this.modal.hasAttribute("open")) {
                  // La modale a été fermée
                  this.reset();
                } else {
                  // La modale a été ouverte
                  setTimeout(() => {
                    this.showFirstStep();
                  }, 50); // Petit délai pour s'assurer que la modale est complètement chargée
                }
              }
            });
          });

          observer.observe(this.modal, { attributes: true });
        }
      }

      initSteps() {
        // Collecter toutes les étapes
        const stepElements = this.querySelectorAll(".compatibility-popup-step-quizz");
        stepElements.forEach((step) => {
          const identifier = step.dataset.identifier;
          if (identifier) {
            this.steps[identifier] = step;
            // Cacher toutes les étapes au début
            step.style.display = "none";

            // Initialiser spécialement les étapes "product-buy" qui nécessitent de cloner le formulaire
            if (step.classList.contains("compatibility-popup-step-quizz-product-buy")) {
              this.initProductBuyStep(step);
            }

            // Cacher le bouton trigger dans l'étape product-buy
            if (step.classList.contains("compatibility-popup-step-quizz-product-buy")) {
              const triggerButton = document.querySelector(".compatibility-popup-button--trigger");
              if (triggerButton) {
                step.dataset.hideTriggerButton = "true";
              }
            }
          }
        });
      }

      initProductBuyStep(step) {
        // Trouver le conteneur où injecter le formulaire dans l'étape
        const formContainer = step.querySelector(".compatibility-popup-step-quizz-product-buy__form-container");
        if (!formContainer) return;

        // On ne clone pas tout de suite le formulaire, on le fera seulement quand cette étape sera affichée
        step.dataset.needsFormInjection = "true";
      }

      injectProductForm(step) {
        // Ne rien faire si l'étape n'est pas de type product-buy ou si l'injection a déjà été faite
        if (!step.classList.contains("compatibility-popup-step-quizz-product-buy") || step.dataset.needsFormInjection !== "true") {
          return;
        }

        // Obtenir le formulaire de produit de la page
        const productForm = document.querySelector(".product-detail__form");
        if (!productForm) {
          console.warn("Formulaire de produit non trouvé sur la page");
          return;
        }

        // Trouver le conteneur où injecter le formulaire
        const formContainer = step.querySelector(".compatibility-popup-step-quizz-product-buy__form-container");
        if (!formContainer) return;

        // Créer un conteneur temporaire
        const tempContainer = document.createElement("div");

        // Filtrer et injecter uniquement les éléments souhaités
        this.elementsToKeep.forEach((selector) => {
          // Pour les éléments sans point ou dièse, on considère que c'est un tag
          const isTag = !selector.includes(".") && !selector.includes("#");

          // Sélectionner les éléments dans le formulaire d'origine
          const elements = isTag ? productForm.getElementsByTagName(selector) : productForm.querySelectorAll(selector);

          // Cloner et ajouter chaque élément au conteneur temporaire
          Array.from(elements).forEach((element) => {
            const clone = element.cloneNode(true);

            // Ne pas préfixer les IDs pour deployer-quantity-breaks
            if (element.tagName.toLowerCase() === "deployer-quantity-breaks" || element.closest("deployer-quantity-breaks")) {
              // Pour deployer-quantity-breaks, on ne modifie pas les IDs
              // car cela pourrait interférer avec son fonctionnement
            } else {
              // Pour les autres éléments, on préfixe les IDs
              this.makeIdsUnique(clone);
            }

            tempContainer.appendChild(clone);
          });
        });

        // Vider et injecter le contenu filtré
        formContainer.innerHTML = "";
        formContainer.appendChild(tempContainer);

        // Marquer comme injecté
        step.dataset.needsFormInjection = "false";

        // Initialiser les éventuels scripts/comportements du formulaire
        this.initProductFormScripts(formContainer);

        // Initialiser le comportement spécial pour deployer-quantity-breaks
        this.setupQuantityBreaksSync(formContainer);
      }

      setupQuantityBreaksSync(formContainer) {
        // Trouver le composant deployer-quantity-breaks dans la popup
        const popupQuantityBreaks = formContainer.querySelector("deployer-quantity-breaks");
        if (!popupQuantityBreaks) return;

        // Trouver le formulaire principal dans la popup
        const popupForm = formContainer.querySelector('form[action="/cart/add"]');
        if (!popupForm) return;

        // Créer un MutationObserver pour détecter les changements dans le deployer-quantity-breaks
        const observer = new MutationObserver(() => {
          // Synchroniser les quantités entre le formulaire original et le formulaire cloné
          this.syncQuantityInputs(popupForm);
        });

        // Observer les changements dans le composant deployer-quantity-breaks
        observer.observe(popupQuantityBreaks, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ["class", "data-quantity"],
        });

        // Réinitialiser deployer-quantity-breaks pour s'assurer qu'il fonctionne correctement
        this.resetDeployerQuantityBreaks(popupQuantityBreaks, popupForm);
      }

      resetDeployerQuantityBreaks(quantityBreaks, form) {
        // S'assurer que le composant sait qu'il doit cibler le formulaire dans la popup
        if (quantityBreaks && form) {
          // Créer un nouvel événement pour simuler un changement de variant
          // Cela force le composant à se réinitialiser avec le formulaire correct
          const event = new CustomEvent("deployer-quantity-breaks:reset", {
            detail: { form: form },
          });

          // Laisser le temps au DOM de se stabiliser
          setTimeout(() => {
            // Trouver et réinitialiser tous les boutons de quantité
            const quantityBreakButtons = quantityBreaks.querySelectorAll(".quantity-break");
            if (quantityBreakButtons.length > 0) {
              // Réinitialiser le bouton sélectionné
              const selectedButton = quantityBreaks.querySelector(".selected-quantity-break") || quantityBreakButtons[0];

              // Cliquer sur le bouton sélectionné pour déclencher la mise à jour
              if (selectedButton) {
                selectedButton.click();
              }
            }

            // Déclencher l'événement de réinitialisation
            document.dispatchEvent(event);
          }, 100);
        }
      }

      syncQuantityInputs(popupForm) {
        if (!popupForm) return;

        // Trouver l'entrée de quantité dans le formulaire cloné
        const popupQuantityInput = popupForm.querySelector('input[name="quantity"]');
        if (!popupQuantityInput) return;

        // Trouver le composant deployer-quantity-breaks associé
        const popupQuantityBreaks = popupForm.closest(".compatibility-popup-step-quizz-product-buy__form-container").querySelector("deployer-quantity-breaks");
        if (!popupQuantityBreaks) return;

        // Trouver le bouton de quantité actuellement sélectionné
        const selectedBreak = popupQuantityBreaks.querySelector(".selected-quantity-break");
        if (selectedBreak) {
          // Mettre à jour la valeur de la quantité dans le formulaire
          const quantity = selectedBreak.getAttribute("data-quantity");
          if (quantity && popupQuantityInput.value !== quantity) {
            popupQuantityInput.value = quantity;
          }
        }
      }

      makeIdsUnique(element) {
        // Ajouter un préfixe aux IDs pour éviter les conflits
        const prefix = "popup-";

        // Trouver tous les éléments avec un ID
        const elementsWithIds = element.querySelectorAll("[id]");
        elementsWithIds.forEach((el) => {
          const originalId = el.id;
          el.id = prefix + originalId;

          // Mettre à jour également les attributs for des labels qui pointent vers cet ID
          const labels = element.querySelectorAll(`label[for="${originalId}"]`);
          labels.forEach((label) => {
            label.setAttribute("for", prefix + originalId);
          });
        });

        // Mettre à jour les autres attributs qui pourraient référencer des IDs (aria-labelledby, aria-controls, etc.)
        const attributesToCheck = ["aria-labelledby", "aria-controls", "aria-describedby"];
        attributesToCheck.forEach((attr) => {
          const elementsWithAttr = element.querySelectorAll(`[${attr}]`);
          elementsWithAttr.forEach((el) => {
            const ids = el.getAttribute(attr).split(" ");
            const newIds = ids.map((id) => prefix + id);
            el.setAttribute(attr, newIds.join(" "));
          });
        });
      }

      initProductFormScripts(formElement) {
        // Réinitialiser les sélecteurs et autres composants interactifs si nécessaire
        // Cette méthode peut être étendue selon les besoins spécifiques du thème

        // Exemple : gérer la soumission du formulaire
        const form = formElement.querySelector("form");
        if (form) {
          form.addEventListener("submit", (event) => {
            event.preventDefault();

            // Utiliser l'API Fetch pour ajouter au panier sans recharger la page
            const formData = new FormData(form);

            fetch("/cart/add.js", {
              method: "POST",
              body: formData,
            })
              .then((response) => response.json())
              .then((data) => {
                // Succès : fermer la popup ou passer à l'étape suivante
                console.log("Produit ajouté au panier", data);
                this.closeModal();
              })
              .finally(() => {
                location.href = "/cart";
              })
              .catch((error) => {
                console.error("Erreur lors de l'ajout au panier", error);
              });
          });
        }
      }

      updateCartCount() {
        // Cette méthode peut être implémentée pour mettre à jour le compteur de panier
        // Elle dépend de la structure spécifique du thème
        const cartCounters = document.querySelectorAll(".cart-count");

        if (cartCounters.length > 0) {
          fetch("/cart.js")
            .then((response) => response.json())
            .then((cart) => {
              cartCounters.forEach((counter) => {
                counter.textContent = cart.item_count;
                counter.classList.remove("hidden");
              });
            });
        }
      }

      addButtonEventListeners() {
        // Sélectionner uniquement les boutons de navigation entre étapes
        // (ceux qui ont un attribut data-goto-identifier)
        const navigationButtons = this.querySelectorAll(".compatibility-popup-step-quizz__content-button[data-goto-identifier]");

        navigationButtons.forEach((button) => {
          const gotoIdentifier = button.dataset.gotoIdentifier;
          if (gotoIdentifier) {
            button.addEventListener("click", () => this.goToStep(gotoIdentifier));
          }
        });
      }

      showFirstStep() {
        // Vérifier que nous avons des étapes
        if (Object.keys(this.steps).length === 0) {
          console.warn("Aucune étape trouvée dans le quiz de compatibilité");
          return;
        }

        // Afficher la première étape
        const firstStep = Object.values(this.steps)[0];
        if (firstStep) {
          // On ne veut pas enregistrer la première étape dans l'historique
          this.goToStep(firstStep.dataset.identifier, false);
          // Réinitialiser l'historique de navigation
          this.navigationHistory = [];
          // Cacher le bouton de retour pour la première étape
          this.updateBackButtonVisibility();
        } else {
          console.warn("Impossible de trouver la première étape");
        }
      }

      goToStep(identifier, addToHistory = true) {
        // Si on n'a pas d'étape courante (ex: première étape), ne rien ajouter à l'historique
        if (addToHistory && this.currentStep) {
          // Ajouter l'étape actuelle à l'historique avant de naviguer à la nouvelle étape
          const currentIdentifier = this.currentStep.dataset.identifier;
          if (currentIdentifier) {
            this.navigationHistory.push(currentIdentifier);
          }
        }

        // Cacher l'étape courante
        if (this.currentStep) {
          this.currentStep.style.display = "none";

          // Si on quitte une étape product-buy, on peut réafficher le bouton trigger s'il était caché
          if (this.currentStep.classList.contains("compatibility-popup-step-quizz-product-buy") && this.currentStep.dataset.hideTriggerButton === "true") {
            const triggerButton = document.querySelector(".compatibility-popup-button--trigger");
            if (triggerButton) {
              triggerButton.style.display = "";
            }
          }
        }

        // Afficher la nouvelle étape
        const nextStep = this.steps[identifier];
        if (nextStep) {
          // Si c'est une étape product-buy, injecter le formulaire avant d'afficher
          if (nextStep.classList.contains("compatibility-popup-step-quizz-product-buy") && nextStep.dataset.needsFormInjection === "true") {
            this.injectProductForm(nextStep);
          }

          // Si c'est une étape product-buy, cacher le bouton trigger
          if (nextStep.classList.contains("compatibility-popup-step-quizz-product-buy") && nextStep.dataset.hideTriggerButton === "true") {
            const triggerButton = document.querySelector(".compatibility-popup-button--trigger");
            if (triggerButton) {
              triggerButton.style.display = "none";
            }
          }

          nextStep.style.display = "block";
          this.currentStep = nextStep;

          // Envoyer l'événement de suivi pour mesurer l'arrivée sur cette étape
          this.trackStepView(identifier);

          // Mettre à jour la visibilité du bouton retour
          this.updateBackButtonVisibility();
        } else {
          console.warn(`Étape "${identifier}" non trouvée`);
        }
      }

      trackStepView(stepIdentifier) {
        // Initialiser l'objet igEvents s'il n'existe pas
        window.igEvents = window.igEvents || [];

        // Transformer l'identifiant technique en nom descriptif
        let stepName = "";
        switch (stepIdentifier) {
          case "debut":
            stepName = "etape: chasse d'eau";
            break;
          case "distance":
            stepName = "etape: distance";
            break;
          case "distance-interieure":
            stepName = "etape: distance interieure";
            break;
          case "arrivee-deau":
            stepName = "etape: arrivée d'eau";
            break;
          case "boku-mini":
            stepName = "etape finale: Boku mini";
            break;
          case "abattant":
            stepName = "etape finale: Abattant";
            break;
          case "bidet-boku":
            stepName = "etape finale: Bidet";
            break;
          case "formulaire":
            stepName = "etape finale: Formulaire";
            break;
          default:
            stepName = `etape: ${stepIdentifier}`;
        }

        // Envoyer l'événement avec le nom descriptif de l'étape
        window.igEvents.push({
          event: "compatibility_popup_step_view",
          step_name: stepName,
        });
      }

      goBack() {
        // S'il n'y a pas d'historique, ne rien faire
        if (this.navigationHistory.length === 0) {
          return;
        }

        // Récupérer la dernière étape de l'historique
        const previousStepIdentifier = this.navigationHistory.pop();

        // Aller à cette étape sans l'ajouter à l'historique
        this.goToStep(previousStepIdentifier, false);
      }

      updateBackButtonVisibility() {
        if (!this.backButton) return;

        // Vérifier s'il y a un historique (donc on peut retourner en arrière)
        // OU si l'étape courante n'est pas la première étape
        const firstStepIdentifier = Object.keys(this.steps)[0];
        const isFirstStep = this.currentStep && this.currentStep.dataset.identifier === firstStepIdentifier;

        if (this.navigationHistory.length > 0 || (this.currentStep && !isFirstStep)) {
          this.backButton.classList.add("is-visible");
        } else {
          this.backButton.classList.remove("is-visible");
        }
      }

      // Réinitialiser la popup
      reset() {
        // Cacher toutes les étapes
        Object.values(this.steps).forEach((step) => {
          step.style.display = "none";

          // Réinitialiser également l'état d'injection des formulaires si nécessaire
          if (step.classList.contains("compatibility-popup-step-quizz-product-buy")) {
            step.dataset.needsFormInjection = "true";
            const formContainer = step.querySelector(".compatibility-popup-step-quizz-product-buy__form-container");
            if (formContainer) {
              formContainer.innerHTML = "";
            }
          }
        });

        // Réinitialiser l'étape courante
        this.currentStep = null;

        // Réinitialiser l'historique de navigation
        this.navigationHistory = [];

        // Mettre à jour la visibilité du bouton retour
        this.updateBackButtonVisibility();

        // Réafficher le bouton trigger s'il était caché
        const triggerButton = document.querySelector(".compatibility-popup-button--trigger");
        if (triggerButton) {
          triggerButton.style.display = "";
        }
      }

      closeModal() {
        if (this.modal) {
          this.modal.removeAttribute("open");
        }
      }

      // Méthode publique pour ouvrir le popup
      open() {
        if (this.modal) {
          // Réinitialiser d'abord pour s'assurer de bien commencer depuis le début
          this.reset();

          // Utiliser la méthode show() de la classe ModalDialog
          this.modal.show();

          // Note: on ne met pas showFirstStep() ici car il sera appelé via le MutationObserver
          // quand l'attribut 'open' sera ajouté à la modale
        }
      }
    }
  );
}
